import axios from "axios";

const api = axios.create({
    // baseURL: 'https://localhost:44384/api/customer',
    baseURL: "https://yiannis-api.ginilytics.com/api/customer",
    headers: {
        'Content-Type': 'application/json',
    }
});
api.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('accessToken');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

// export const imageURL = 'https://localhost:44384';
export const imageURL = 'https://yiannis-api.ginilytics.com';
// export const notificationURL = 'https://localhost:44384/notificationHub';
export const notificationURL = 'https://yiannis-api.ginilytics.com/notificationHub';
// export const publishableKey = "pk_test_51RNob1LeLlNxdCvsU2DdKQzxdFnMopiP0Bcmdwej33H0LDDegWYX4hZ3Egrf9oetBzeFuV00fHh59mFpThnuXUz000NV0fyZ3D";
export const publishableKey = "pk_live_51RNob1LeLlNxdCvsdu0KXaS2kQHYkkgElumiY7XDJKVpuwTAahFFswzCB2TUi489u3i4tLkS3FX15EdvWnPZPH3n00opCsD1l6";

export default api;